module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/7ac75f73fe52840f35e072e389ef4a94.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/images/img_question_marks_right.svg
// module id = 11tP
// module chunks = 0